import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked reveal for large display headings
export const MaskLines = ({ lines, className = "", lineClassName = "", startDelay = 0 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: startDelay + i * 0.12, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const Label = ({ children, className = "" }) => (
  <span
    className={`font-mono text-xs tracking-[0.28em] uppercase text-manor-sage ${className}`}
  >
    {children}
  </span>
);
